export const FormFields = {
    EmailId: {
      id: "userId",
      labelId: "userIdLabel",
      type: "text",
      title: "Email address (or create a unique user id)",
    //   fieldInfo: "Type at least four characters",
      requiredErr: "Please enter a Email Id",
      maxlength: 50,
      tabIndex: 0,
      required: true,
      wrapperClassName: "col-md-12 container-row",
      ariaDescribedBy: "userIdLabel-error-message",
      validateOnBlur: true,
      validateOnChange: true,
      className: "broker-input-field",
      labelClassName: "broker-form-label",
      formControlClassName: "brooker-form-control row",
      validation: {
        required: {
          message: "Userid is required"
        },
        maxLength: { maxLength: 50, message: "User Id is not valid format" },
        minLength: { minLength: 8, message: "User Id is not valid format" },
        regex: {
          regex: /^[a-zA-Z0-9-_@.]+$/,
          message: "User Id is not valid format"
        }
      }
    },
    PhoneNumber: {
      ariaDescribedBy: "userIdLabel-error-message",
      className: "broker-input-field",
      formControlClassName: "brooker-form-control row",
      id: "userPhoneNumber",
      labelClassName: "broker-form-label",
      labelId: "userPhoneNumberLabel",
      maxlength: 12,
      required: true,
      requiredErr: "Please enter a Phone number",
      tabIndex: 0,
      placeholder: "Enter phone no. e.g. 123-456-7890",
      title: "Phone number",
      type: "text",
      validateOnBlur: true,
      validateOnChange: true,
      wrapperClassName: "col-md-12 container-row",
    //   fieldInfo: "Type at least four characters",
      validation: {
        required: {
          message: "Phone number is required"
        },
        maxLength: { 
          maxLength: 12,
          message: "Phone number is not valid format"
        },
        regex: {
          regex: /^\d{3}-\d{3}-\d{4}$/,
          message: "Enter 10 digit phone no. Allowed: 0 to 9"
        }
      }
    },
    Password: {
      id: "password",
      labelId: "passwordlabel",
      type: "password",
      title: "Create a password",
      fieldInfo: "Type Password",
      requiredErr: "Please enter password",
      // maxlength: 8,
      tabIndex: 0,
      required: true,
      isOptional: false,
      validateOnBlur: true,
      validateOnChange: true,
      wrapperClassName: "col-md-12",
      ariaDescribedBy: "passwordlabel-error-message",
      className: "password-input",
      labelClassName: "broker-form-label",
      formControlClassName: "brooker-form-control row",
      validation: {
        required: {
          message: "Create Password is required"
        },
      }
    },
  };